module.exports = __webpack_public_path__ + "img/result_ceil_angle.1ee2245e.jpg";